import { render, staticRenderFns } from "./PhotopointList.vue?vue&type=template&id=536af977&"
import script from "./PhotopointList.vue?vue&type=script&lang=js&"
export * from "./PhotopointList.vue?vue&type=script&lang=js&"
import style0 from "./PhotopointList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports